/**
 * Zabrání změně hodnoty v `<input type="number">` kolečkem myši.
 *
 * Chrome/Edge (hlavně na Windows) při scrollování nad označeným číselným
 * polem mění číslo místo posunu stránky — kolegyním se tak při zadávání
 * zakázky nenápadně přepisovaly kusy u velikostí. Pole při scrollu jen
 * odoznačíme (blur), stránka se pak normálně posune a hodnota zůstane.
 */
export function preventNumberInputWheel(): void {
  document.addEventListener(
    'wheel',
    (e) => {
      const target = e.target;
      if (
        target instanceof HTMLInputElement &&
        target.type === 'number' &&
        target === document.activeElement
      ) {
        target.blur();
      }
    },
    { passive: true, capture: true },
  );
}
